import React from 'react'
import Helmet from 'react-helmet'

// import LazyImage from '../components/LazyImage'
import Content from '../components/Content.js'
import Header from "../components/Nav.js";
import './About.css'

export default ({ page }) => {
  const { title, section1 } = page
  return (
    <div className='About'>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header />
      <div className="AboutTitle">{title}</div>
      <div className='sectionAbout'>
        <div className='containerAbout'>
          <Content source={section1} />
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/About.js